var persistentPopupOutlet = '_1pz8ves0';

export { persistentPopupOutlet };
//# sourceMappingURL=persistent-popup-outlet.css.js.map
